var _rect, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 400,
    height: 100,
    viewBox: "0 0 400 100",
    id: "bb911528-14b9-455f-b042-2cc90a6234f9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 100,
    fill: "none",
    "data-cmyk": "none"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    x: 0,
    y: 0,
    height: 100,
    width: 100,
    textAnchor: "left",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 313.29 328.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".class665132f44aea9cls-1{fill:#f5530c;data-cmyk=cmyk(0,66,95,4);}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 10") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "class665132f44aea9cls-1",
    d: "M.55.79,17.73,273.1,216.56,328l96.05-188.82ZM113.67,262.92a6.93,6.93,0,0,1-13.85,0V91.38a6.93,6.93,0,0,1,13.85,0Zm107.77,8.14H149.52a7,7,0,0,1-6.16-4.18,6.68,6.68,0,0,1-1.76-4.62V217.62a6.93,6.93,0,0,1,13.86,0V257h66a7.07,7.07,0,0,1,7,7A7.23,7.23,0,0,1,221.44,271.06Z"
  })))))), /*#__PURE__*/React.createElement("text", {
    fill: "#f5530c",
    "data-cmyk": "cmyk(0,66,95,4)",
    fontSize: 80,
    x: 110,
    y: 59,
    textAnchor: "left",
    lengthAdjust: "spacing",
    id: "e40a89e2-eb07-4584-ae6b-7c8991c16f2e",
    width: 290,
    fontFamily: "Arial",
    style: {
      fontSize: 51
    }
  }, "Logogen"), /*#__PURE__*/React.createElement("text", {
    fill: "#808080",
    "data-cmyk": "cmyk(0,0,0,50)",
    fontSize: 25,
    x: 110,
    y: 96,
    textAnchor: "left",
    id: "2e8bd16f-bb2c-4258-a4d2-e438ad31561f",
    width: 290,
    fontFamily: "Arial",
    style: {
      fontSize: 23
    }
  }, "AI Logo Generator"));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.656e9d1e3643381aad0b10de0cde3e3f.svg";
export { ForwardRef as ReactComponent };